import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import LandingPage from "@/pages/Landing";
import LoginPage from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { Impressum, Datenschutz, AGB } from "@/pages/Legal";
import CookieConsent from "@/components/CookieConsent";
import {
  StudioHome, AppLanding, AppPrivacy, AppSupport, AppTerms,
  StudioImpressum, StudioDatenschutz, StudioAGB
} from "@/pages/apps/AppsStudio";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<Navigate to="/login" replace />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/agb" element={<AGB />} />
      <Route path="/apps" element={<StudioHome />} />
      <Route path="/apps/impressum" element={<StudioImpressum />} />
      <Route path="/apps/datenschutz" element={<StudioDatenschutz />} />
      <Route path="/apps/agb" element={<StudioAGB />} />
      <Route path="/apps/:app" element={<AppLanding />} />
      <Route path="/apps/:app/privacy" element={<AppPrivacy />} />
      <Route path="/apps/:app/support" element={<AppSupport />} />
      <Route path="/apps/:app/terms" element={<AppTerms />} />
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <CookieConsent />
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#0A0A0A",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "#fafafa",
                },
              }}
            />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}
